var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { TextField } from '@mui/material';
import DateTimePickerWithTimeZone from '../atoms/DateTimePickerWithTimeZone';
function EditDateTimePickerWithTimeZone(props) {
    var value = props.value, onChange = props.onChange;
    var handleChange = function (value) {
        var date = value;
        date.setMinutes(0);
        date.setSeconds(0);
        onChange(date);
    };
    return (React.createElement(DateTimePickerWithTimeZone, { value: value ? new Date(value) : null, onChange: handleChange, renderInput: function (inputProps) { return (React.createElement(TextField, __assign({}, inputProps, { fullWidth: true, margin: "normal", variant: "standard" }))); } }));
}
export default EditDateTimePickerWithTimeZone;
